import React from "react";
import "../Styles/agent-section.css"; // create and link this CSS
import { useNavigate } from "react-router-dom";

export default function AgentSection() {
  const navigate = useNavigate();

  return (
    <section className="agent-section-container">
      <div className="card-agent light-card">
        <h2 className="agent-title">
          {" "}
          Join us and Connect with an Agent today!
        </h2>
        <p className="agent-description">
          <strong>
            {" "}
            You can explore matches on your own or choose one of our trusted,
            registered local matrimony agents{" "}
          </strong>{" "}
          —each specializing in specific communities and offering strong,
          meaningful connections within those circles.
        </p>
        <p className="agent-description">
          Your agent will guide you at every step, from creating your profile to
          finding and verifying the right match, ensuring a smooth, supportive,
          and well‑guided experience throughout your journey.
        </p>
        <a href="/browseagents" className="agent-link-browse">
          Browse for an agent ❯
        </a>
      </div>

      <div className="card tinted-card">
        <h2 className="agent-title">Become an Agent and grow with WedLuk!</h2>
        <p className="agent-description">
          <strong>
            Start your own matchmaking agency without any investment.
          </strong>{" "}
          With WedLuk, you can build a personal, home‑based agency that serves
          your own community and beyond. Our platform helps you deliver
          stronger, more precise matches using advanced AI tools that simplify
          your work and enhance your credibility.
        </p>
        <p className="agent-description">
          By joining the WedLuk Agent Network, you simply add your agency name
          and details and instantly connect with trusted agents across regions —
          expanding your reach, strengthening your matchmaking capabilities, and
          creating meaningful impact within your community.
        </p>
        <a href="/signup" className="agent-link-browse orange">
          Sign up now ❯
        </a>
      </div>
    </section>
  );
}
